import { useSyncExternalStore } from "react";

export type NetworkStatus = "online" | "offline";

const listeners = new Set<() => void>();
let current: NetworkStatus =
  typeof navigator !== "undefined" && navigator.onLine === false ? "offline" : "online";
let attached = false;

function read(): NetworkStatus {
  return current;
}

function notify() {
  for (const listener of listeners) listener();
}

function set(next: NetworkStatus) {
  if (next !== current) {
    current = next;
    notify();
  }
}

function ensureAttached() {
  if (attached || typeof window === "undefined") return;
  attached = true;
  window.addEventListener("online", () => set("online"));
  window.addEventListener("offline", () => set("offline"));
}

function subscribe(listener: () => void) {
  ensureAttached();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useNetworkStatus(): NetworkStatus {
  return useSyncExternalStore(subscribe, read, read);
}
